//
// StyleChain.js
// commons
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "../moduleBuilder";
import ClosetObject from "../ClosetObject";
import "../lib";
import "./AttributeBundle";
import "../util/Dimension";

var StyleChain = createModule("commons_StyleChain", [153], ClosetObject, [
    ,
    ,
    ,
    ,
    {
        getStyleAttributeBoolValue: [2,4,2],
        getStyleAttributeStringValue: [7,4,7],
        hasStyleAttributeValue: [2,4],
        getStyleAttributeDimensionValue: [1,4,1],
        hasStyleAttributeValueAboveBase: [2,4],
        getOrderedBundles: [[1]],
        getStyleAttributeUnsignedValue: [3,4,3],
        getDescription: [7],
        getStyleAttributeFloatValue: [5,4,5],
    },
    {
        _create_o: [4,[1]],
        _create_oo: [4,1,[4]],
    },
    ,
    ["_create"]
]);
export default StyleChain;
